import { DataTable } from '@r/components/data-table/data-table.tsx';
import { useDataTable } from '@r/hooks/use-data-table.ts';
import { useTypologiesColumns } from './typologies-columns.tsx';
import { CreateTypologyDialog } from './create-typology-dialog.tsx';
import type { FC } from 'react';
import type {
  TypologyTypologyReadModel,
  TypologyTypologyWriteModel
} from '@r/api/generated/client.schemas.ts';

type Typology = TypologyTypologyReadModel | TypologyTypologyWriteModel;

interface TypologiesTableProps {
  data: Typology[];
  onCreateSuccess: (typology: TypologyTypologyWriteModel) => void | Promise<void>;
  onEdit?: (typology: TypologyTypologyReadModel) => void;
  onDelete?: (typology: TypologyTypologyReadModel) => void;
  canCreate?: boolean;
  useLocalState?: boolean;
  createdAt?: boolean;
}

export const TypologiesTable: FC<TypologiesTableProps> = ({
  data,
  onCreateSuccess,
  onEdit,
  onDelete,
  canCreate = true,
  useLocalState,
  createdAt = false
}) => {
  const { table } = useDataTable<Typology, unknown>({
    data: data ?? [],
    columns: useTypologiesColumns(createdAt, onEdit, onDelete),
    pageCount: 1
  });

  return (
    <div className="space-y-6">
      <DataTable table={table} pagination={false} />

      {canCreate && (
        <CreateTypologyDialog
          onSubmitSuccess={(t) => onCreateSuccess(t as TypologyTypologyWriteModel)}
          useLocalState={useLocalState}
          typologies={data as Partial<TypologyTypologyReadModel>[]}
        />
      )}
    </div>
  );
};
